import NoticeCard from "./NoticeCard";
import { buildGuidedNotice } from "../../utils/guidedErrors";

/**
 * Renders a NoticeCard with step-by-step guidance + deep links for first-time users.
 *
 * @param {"employee"|"attendance"|"leave"|"payroll"|"general"} domain
 * @param {unknown} error - axios error, string, or guided notice object
 */
export default function GuidedNotice({
  domain = "general",
  error,
  message,
  variant = "warning",
  stepsTitle = "What you can do",
  onDismiss,
  className = "",
}) {
  const notice = buildGuidedNotice(domain, error ?? message);
  if (!notice) return null;

  return (
    <div className={className || undefined}>
      <NoticeCard
        variant={variant}
        title={notice.title}
        message={notice.message}
        hint={notice.hint}
        steps={notice.steps}
        stepsTitle={stepsTitle}
        guideLinks={notice.guideLinks}
        onDismiss={onDismiss}
      />
    </div>
  );
}
